function getActiveClass(idCurrent, idItem) {
  if (idCurrent === idItem) {
    return 'active';
  }

  return '';
}

export default getActiveClass;
